import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function About() {
  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: '关于我们' },
  ];

  const seoJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于香蕉影视',
    description: '香蕉影视品牌介绍、口碑评价和联系方式。高清免费在线观看平台，致力于为用户提供最流畅的观影体验。',
    url: 'https://www.xiangjiaoys.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '香蕉影视',
      url: 'https://www.xiangjiaoys.com/',
    },
    about: {
      '@type': 'Organization',
      name: '香蕉影视',
      description: '香蕉影视提供高清免费在线观看，不缓冲秒开，最新热播电影、电视剧、综艺大全，全集免费在线看。',
      url: 'https://www.xiangjiaoys.com/',
    },
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '香蕉影视是否真的免费？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，香蕉影视所有影视资源均免费在线观看，无需注册登录，无需付费会员，打开即看。我们致力于为用户提供零门槛的高清观影体验。',
        },
      },
      {
        '@type': 'Question',
        name: '香蕉影视的播放画质如何？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '香蕉影视支持最高4K超高清画质播放，采用先进的视频编码和CDN加速技术，确保画面清晰流畅，为您带来影院级的观影享受。',
        },
      },
      {
        '@type': 'Question',
        name: '播放时会不会有缓冲或卡顿？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '香蕉影视采用全球领先的智能加速技术，基于用户网络环境自动优化码率，真正做到不缓冲、不卡顿、秒开播放。无论您使用WiFi还是移动网络，都能畅享流畅观影。',
        },
      },
      {
        '@type': 'Question',
        name: '香蕉影视支持哪些设备观看？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '香蕉影视全面支持手机、平板、电脑等各类设备。网页端无需下载任何插件或APP，打开浏览器即可观看。界面自适应不同屏幕尺寸，带给您舒适的跨设备观影体验。',
        },
      },
      {
        '@type': 'Question',
        name: '香蕉影视的内容多久更新一次？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '香蕉影视内容团队24小时不间断更新，每日都有最新热播电影、电视剧、综艺节目上线。热门剧集与电视台同步更新，确保您第一时间看到最新内容。',
        },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(seoJsonLd) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }} />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <div className="bg-background-100 border-b border-background-200/70">
            <Breadcrumb items={breadcrumbItems} />
          </div>

          <section className="w-full px-4 md:px-6 py-12 md:py-16 max-w-4xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-8 text-center">
              关于香蕉影视
            </h1>

            <div className="space-y-12">
              <div>
                <h2 className="text-xl font-heading font-bold text-foreground-900 mb-4 flex items-center gap-2">
                  <span className="w-1 h-6 bg-primary-500 rounded-full inline-block"></span>
                  品牌介绍
                </h2>
                <div className="text-foreground-600 leading-relaxed space-y-3 text-sm md:text-base">
                  <p>
                    香蕉影视成立于2020年，是国内领先的<strong>高清免费在线观看</strong>平台。
                    我们致力于为广大影视爱好者提供最优质的观影服务，让每一位用户都能享受到<strong>不缓冲、秒开播放</strong>的极致体验。
                  </p>
                  <p>
                    平台汇聚了超过1000部最新<strong>热播电影、电视剧、综艺节目</strong>，涵盖动作、喜剧、科幻、悬疑、爱情、古装等多种类型。
                    无论您喜欢哪种风格的影视作品，都能在香蕉影视找到心头好。
                  </p>
                  <p>
                    我们深知用户在追剧过程中的痛点——漫长的加载时间、频繁的缓冲卡顿、模糊不清的画质。
                    正是这些痛点的存在，让我们下定决心打造一个真正<strong>高清流畅、不卡顿</strong>的观影平台。
                    经过多年的技术积累和持续优化，香蕉影视的播放体验已经达到了行业领先水平。
                  </p>
                </div>
              </div>

              <div>
                <h2 className="text-xl font-heading font-bold text-foreground-900 mb-4 flex items-center gap-2">
                  <span className="w-1 h-6 bg-accent-500 rounded-full inline-block"></span>
                  用户口碑
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  {[
                    {
                      name: '追剧达人小王',
                      text: '自从用了香蕉影视，再也不用忍受其他平台的广告和卡顿了。画质清晰，资源更新快，真心推荐！',
                      rating: 5,
                    },
                    {
                      name: '电影爱好者老李',
                      text: '香蕉影视的资源真的很全，很多冷门好片都能找到。高清画质看大片太过瘾了，已经推荐给身边所有朋友。',
                      rating: 5,
                    },
                    {
                      name: '综艺迷小张',
                      text: '综艺更新速度太快了，几乎和电视同步！周末窝在家里一口气看完整季，爽！',
                      rating: 5,
                    },
                    {
                      name: '学生党阿明',
                      text: '免费是真的免费，没有任何套路。对于我们学生来说太友好了，课余时间追剧的最佳选择。',
                      rating: 5,
                    },
                    {
                      name: '宝妈小雨',
                      text: '孩子看动画片很方便，资源多还不卡顿。自己追剧也用这个，画面比很多收费平台还好。',
                      rating: 4,
                    },
                    {
                      name: '上班族大刘',
                      text: '通勤路上用手机看，流畅不卡。下班回家用电脑看4K电影，体验超级棒。香蕉影视YYDS！',
                      rating: 5,
                    },
                  ].map((review, idx) => (
                    <div key={idx} className="p-5 bg-background-100 rounded-lg">
                      <div className="flex items-center gap-1 mb-2">
                        {Array.from({ length: 5 }).map((_, i) => (
                          <i
                            key={i}
                            className={`text-xs ${i < review.rating ? 'ri-star-fill text-primary-500' : 'ri-star-line text-foreground-400'}`}
                          ></i>
                        ))}
                      </div>
                      <p className="text-sm text-foreground-600 leading-relaxed mb-3">&ldquo;{review.text}&rdquo;</p>
                      <p className="text-xs text-foreground-500 font-medium">{review.name}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <h2 className="text-xl font-heading font-bold text-foreground-900 mb-4 flex items-center gap-2">
                  <span className="w-1 h-6 bg-secondary-500 rounded-full inline-block"></span>
                  联系我们
                </h2>
                <div className="bg-background-100 rounded-lg p-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-full flex-shrink-0">
                        <i className="ri-mail-line text-primary-600"></i>
                      </div>
                      <div>
                        <h4 className="text-sm font-medium text-foreground-800 mb-1">电子邮箱</h4>
                        <p className="text-sm text-foreground-500">contact@xiangjiaoys.com</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-full flex-shrink-0">
                        <i className="ri-customer-service-2-line text-accent-600"></i>
                      </div>
                      <div>
                        <h4 className="text-sm font-medium text-foreground-800 mb-1">客服微信</h4>
                        <p className="text-sm text-foreground-500">xiangjiao_kefu</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center bg-secondary-100 rounded-full flex-shrink-0">
                        <i className="ri-time-line text-secondary-600"></i>
                      </div>
                      <div>
                        <h4 className="text-sm font-medium text-foreground-800 mb-1">服务时间</h4>
                        <p className="text-sm text-foreground-500">周一至周日 9:00 - 22:00</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-full flex-shrink-0">
                        <i className="ri-map-pin-line text-primary-600"></i>
                      </div>
                      <div>
                        <h4 className="text-sm font-medium text-foreground-800 mb-1">公司地址</h4>
                        <p className="text-sm text-foreground-500">北京市朝阳区望京科技园A座</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}